<template>
  <div>
    <br />
    <!-- <pre>{{ datacollection.datasets[0].data }}</pre> -->
    <vs-row style="align-items: center">
      <h4 class="text_box2_3_1">Active Power</h4>
      <vs-spacer
    /></vs-row>

    <div style="position: relative; padding: 10px; width: 100%">
      <!-- <displaychart
        width="200"
        height="200"
        :chartdata="chartdata"
        :color="color"
      /> -->
      <LineChart
        v-if="datacollection"
        :width="300"
        :height="200"
        :chartdata="datacollection"
        :options="options"
        :areaColor="colorgraph"
      ></LineChart>
    </div>
    <div class="div_row1" style="align-items: center">
      <div
        style="
          margin-left: 10px;
          width: 45px;
          border-radius: 20px;
          background-color: rgba(20, 153, 242);
          color: rgba(20, 153, 242);
          height: 1.5%;
        "
      >
        .
      </div>
      <a class="ml-1">Active Power</a>
      <vs-spacer />
      <div class="item-flex">
        <div class="mr-4">
          <p style="color: #fc8200" class="mb-1">avg</p>
          <p>{{ value_graph.avg.toFixed(2) }} kW</p>
        </div>
        <div class="mr-4">
          <p style="color: #ff006a" class="mb-1">min</p>
          <p>{{ value_graph.min.toFixed(2) }} kW</p>
        </div>
        <div class="mr-4">
          <p style="color: #d400ff" class="mb-1">max</p>
          <p>{{ value_graph.max.toFixed(2) }} kW</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import displaychart from "./chart1.vue";
import LineChart from "@/components/ChartJs/LineChart.vue";
export default {
  components: {
    displaychart,
    LineChart,
  },
  props: ["chartdata", "color", "datacollection", "value_graph"],
  data() {
    return {
      popupActivo: false,
      number: 20,
      select1: 2,
      options: {
        maintainAspectRatio: false,
        responsive: true,
        legend: false,
        scales: {
          yAxes: [
            {
              // id: "A",
              ticks: {
                beginAtZero: true,
                // steps: 10,
                // stepValue: 5,
                // max: 30,
              },
              // position: "left",
              scaleLabel: {
                display: false,
                // labelString: this.chartdata.tooltip_label,
              },
            },
          ],
        },
      },
      options1: [
        { text: "Min. ", value: 1 },
        { text: "Sec.", value: 2 },
      ],
    };
  },
  methods: {},
  mounted() {console.log(this.chartdata),console.log(this.color),console.log(this.datacollection),console.log(this.value_graph)},
};
</script>

<style scoped>
.text_box2_3_1 {
  margin-left: 10px;
  font-size: 1rem;
  /* width: 100%; */
  font-weight: 600;
  color: #707070;
}
.item-flex {
  display: flex;
  /* justify-content: center; */
}
.div_row1 {
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
}
</style>